import React from "react";
import { useParams } from "react-router-dom";
import { paymentTypes } from "../../constants";

const CheckoutPaymentForm = React.lazy(() => import("./CheckoutPaymentForm"));
const CheckoutFlowPaymentForm = React.lazy(() =>
  import("./CheckoutFlowPaymentForm")
);
const StripePaymentForm = React.lazy(() => import("./StripePaymentForm"));

export const PaymentForm = (props) => {
  const provider = process.env.REACT_APP_PAYMENT_PROVIDER || "checkout";

  // Kill-switch for the Checkout.com Frames -> Flow migration. Defaults to the
  // proven legacy Frames path; opt into the new Flow path by building with
  // REACT_APP_CHECKOUT_SDK=flow. Frames-by-default keeps an unconfigured or
  // unvalidated prod deploy on the working form instead of the new path (which
  // also needs the backend createCheckoutPaymentSession resolver deployed).
  // REACT_APP_* vars are inlined at build time, so flipping this is a redeploy.
  const useFlow = process.env.REACT_APP_CHECKOUT_SDK === "flow";

  // Key the Flow form by iaSession so a change to the route param remounts it,
  // re-minting a fresh Checkout payment session for the new session. Flow's
  // init effect is intentionally once-per-mount (StrictMode-safe), so without a
  // remount it would keep a session minted for the old iaSession while
  // storeCheckoutInstrument used the new one.
  const { iaSession } = useParams();

  return (
    <>
      <React.Suspense fallback={<></>}>
        {provider === paymentTypes.CHECKOUT && useFlow && (
          <CheckoutFlowPaymentForm key={iaSession} {...props} />
        )}
        {provider === paymentTypes.CHECKOUT && !useFlow && (
          <CheckoutPaymentForm {...props} />
        )}
        {provider === paymentTypes.STRIPE && <StripePaymentForm {...props} />}
      </React.Suspense>
    </>
  );
};

export default PaymentForm;
